export const medicalRecordsWeightUnits = {
  kg: 'Kg',
  lbs: 'Lbs',
} as const;

export type MedicalRecordsWeightUnit =
  (typeof medicalRecordsWeightUnits)[keyof typeof medicalRecordsWeightUnits];

export function formatMedicalRecordsWeight(
  weight: number,
  unitFrom: MedicalRecordsWeightUnit,
  unitTo: MedicalRecordsWeightUnit,
): string {
  const kilogramsToPounds = 2.2046226218;
  const poundsToKilograms = 0.45359237;

  if (
    unitFrom === medicalRecordsWeightUnits.kg &&
    unitTo === medicalRecordsWeightUnits.kg
  ) {
    return `${weight} Kg`;
  }

  if (
    unitFrom === medicalRecordsWeightUnits.lbs &&
    unitTo === medicalRecordsWeightUnits.kg
  ) {
    const kilograms = weight * poundsToKilograms;

    return `${Number(kilograms.toFixed(2))} Kg`;
  }

  const totalPounds =
    unitFrom === medicalRecordsWeightUnits.kg
      ? weight * kilogramsToPounds
      : weight;

  let pounds = Math.floor(totalPounds);
  let ounces = Math.round((totalPounds - pounds) * 16);

  if (ounces === 16) {
    pounds += 1;
    ounces = 0;
  }

  return ounces === 0 ? `${pounds} Lbs` : `${pounds} Lbs ${ounces} Oz`;
}
